import React from 'react';

export const ModulesSection = ({ features }) => {
  return (
    <section id="collections" className="py-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <p className="text-[10px] font-bold tracking-[0.25em] text-[#A27327] uppercase mb-1.5 font-sans">Key Features</p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#1A1A1A] leading-none">Admin Modules</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map(f => (
            <div key={f.title} className="group relative overflow-hidden rounded-2xl bg-white border border-[#ECE7DE] hover:shadow-xl hover:-translate-y-1 transition-all duration-400 cursor-pointer">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={require(`../../../assets/Images/${f.img}.jpg`)}
                  alt={f.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-serif font-bold text-[#1A1A1A] mb-2">{f.title}</h3>
                <p className="text-sm text-[#626262] leading-relaxed font-sans">{f.desc}</p>
                <div className="mt-5 text-[11px] font-bold tracking-widest text-[#C91D25] uppercase group-hover:tracking-[0.25em] transition-all duration-300 font-sans">
                  Explore →
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};




